import Cookies from 'js-cookie'

const TokenKey = 'bbs_front_token'
const userInfoKey = 'bbs_front_user_info'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function setRefreshToken(token) {
  return localStorage.setItem('bbs_front_refresh_token',token)
}
export function getRefreshToken() {
  return localStorage.getItem('bbs_front_refresh_token')
}
export function setSiteInfo(info) {
  info = JSON.stringify(info)
  return localStorage.setItem('bbs_site_info',info)
}
export function getSiteInfo() {
  return JSON.parse(localStorage.getItem('bbs_site_info'))
}
export function setLoginState(state) {
  return Cookies.set('bbs_front_loginState',state)
}
export function getLoginState() {
  return Cookies.get('bbs_front_loginState')
}
export function setUserInfo(info) {
  info = JSON.stringify(info)
  return localStorage.setItem(userInfoKey, info)
}
export function getUserInfo() {
  return JSON.parse(localStorage.getItem(userInfoKey))
}
